import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { api } from "../../evergis/api";
import { getLocation } from "../location/selectors";
import { setSelectedFeatures } from "./selectFeatures";
import { FeatureDcExtended } from "./types";

export function useLocationQueryFeature() {
  const dispatch = useDispatch();
  const location = useSelector(getLocation);

  const { layerName, gid } = location.query || {};

  useEffect(() => {
    (async () => {
      if (!layerName || !gid) return;

      const currentFeature = (await api.layers.getById({ name: layerName, id: gid })) as FeatureDcExtended;

      if (!currentFeature) return;

      dispatch(
        setSelectedFeatures({
          [layerName]: [currentFeature],
        }),
      );
    })();
  }, [layerName, gid]);
}
